import { render, staticRenderFns } from "./commentPanel.vue?vue&type=template&id=7f40cebd&scoped=true&"
import script from "./commentPanel.vue?vue&type=script&lang=js&"
export * from "./commentPanel.vue?vue&type=script&lang=js&"
import style0 from "./commentPanel.vue?vue&type=style&index=0&id=7f40cebd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f40cebd",
  null
  
)

export default component.exports